// remove any special characters and leave only digits separated by comma
// if empty value return null
export const formatSNList = (data) => {
	// replace all non digit characters and multiple commas
	const formattedData = data.replace(/[^\d,]/gi, '').replace(/,+/g, ',');
	return formattedData.length ? formattedData : '';
};
